
    declare let productFiltering:any;
    declare let useFilter:any;
    declare let baseUrlTo3DTour:any;
    declare let filters;
    declare let baseListUrl;
    declare let baseHouseUrl;
    import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
    import "./list-page.less";
    import { getHousesWithFilters } from "../../services/webclient/webclient";
    import { translate } from "../../services/translation/translation";
    import  Paginator  from "../paginator/paginator.vue";


    @Component({
        components: {
            Paginator
        }
    })
    export default class ListPage extends Vue {
        private data ={
            filter: '',
            productFilter: '',
            filters: [],
            propertyFilters: {
                heat_protection_min: 0,
                heat_protection_max: 3,
                heat_storage_min: 0,
                heat_storage_max: 3,
                temperature_storage_min: 0,
                temperature_storage_max: 3,
                sound_proofing_min: 0,
                sound_proofing_max: 3,
                moisture_buffering_min: 0,
                moisture_buffering_max: 3,
                room_acoustics_min: 0,
                room_acoustics_max: 3,
                electromagnetic_absorption_min: 0,
                electromagnetic_absorption_max: 3,
                noticeable_odour_min: 0,
                noticeable_odour_max: 3,
                house_comfort_number_min: 0,
                house_comfort_number_max: 3,
            },
        };
        private paginator = {
            maxPage: 0,
            currentPage: 1,
            itemPerPage: 16,
            from: 0,
            to: 0,
            total: 0,
        };
        private houses = [];
        private loadedHouses = false;
        private openedFilters = false;
        private cookie_name = 'vivapark_compare';
        private propertyFilterTypes = [
            'heat_protection',
            'heat_storage',
            'sound_proofing',
            'moisture_buffering',
            'house_comfort_number',
        ];
        mounted() {
            this.data.filters= filters;
            this.data.filter = useFilter;
            this.data.productFilter = productFiltering;
            this.loadHouses();
            this.initRangeSliders();
        }
        loadHouses(){
            let self = this;
            getHousesWithFilters(self.data.filter,self.data.productFilter,self.data.propertyFilters,self.paginator).then(function(resp){
                if(self.loadedHouses){
                    self.removeAnimations()
                }
                self.houses = resp.houses.data;
                self.paginator.maxPage = resp.houses.last_page;
                self.paginator.from = resp.houses.from;
                self.paginator.to = resp.houses.to;
                self.paginator.total = resp.houses.total;
                setTimeout(function(){
                    self.removeAnimations();
                    self.initAnimations();
                    self.updateCompareButtons();
                },300);
                self.loadedHouses = true;
            });
        }

        initRangeSliders(){
            let self = this;
            $('.house-property-range-slider').each(function(index,slider){
                (window as any).noUiSlider.create(slider, {
                    start: [0, 3],
                    range: { min: [0], '50%': [1.5,0.5],max: [3] },
                    step: 0.5,
                    tooltips: true,
                    connect: true,
                });
                (slider as any).noUiSlider.on('update', function (values, handle) {
                    let value = parseFloat(values[handle]);
                    let property = $(slider).data('property');
                    if(handle){
                        property+='_max';
                    }
                    else{
                        property+='_min';
                    }
                    self.data.propertyFilters[property] = value;
                    if(self.loadedHouses){
                        self.loadHouses();
                    }
                });
            });
            $('.house-property-range-slider-comfort').each(function(index,slider){
                (window as any).noUiSlider.create(slider, {
                    start: [0, 3],
                    range: { min: [0], max: [3] },
                    step: 1,
                    tooltips: true,
                    connect: true,
                });
                (slider as any).noUiSlider.on('update', function (values, handle) {
                    let value = parseFloat(values[handle]);
                    let property = $(slider).data('property');
                    if(handle){
                        property+='_max';
                    }
                    else{
                        property+='_min';
                    }
                    self.data.propertyFilters[property] = value;
                    if(self.loadedHouses){
                        self.loadHouses();
                    }
                });
            });
        }

        updatePropertyfilterState(){
            $('.house-property-filtering').toggleClass('opened');
            this.openedFilters = !this.openedFilters;
        }

        removeAnimations(){
            //a try csak azért van hogy ne kelljen vizsgálni egyáltalán vannak-e megfelelő tooltipek amiket unbindolni akarunk
            try{
                ($('.house-list-container .viva-park-house-card [data-toggle="tooltip"]') as any).tooltip('dispose');
            }
            catch(e){}
            try{
                ($('.list-circle-anim') as any ).tooltip({ trigger: 'manual', placement: 'top' }).tooltip('dispose');
            }
            catch(e){console.log('korte',e);}
        }

        initAnimations(){
            ($('.house-list-container .viva-park-house-card [data-toggle="tooltip"]') as any).tooltip({ trigger: 'hover click', placement: 'top' });
            $('.house-list-container .viva-park-house-card [data-toggle="tooltip"]').on('shown.bs.tooltip', function(e) {
                ($('.viva-park-house-card [data-toggle="tooltip"]').not(this) as any).tooltip('hide');
            });
            $(".list-circle-anim").each(function(index, element) {
                var ID = $(element).attr('id');
                var cVal = $(element).attr('data-val');
                var myCircle = (window as any).Circles.create({
                    id: ID,
                    radius: 25,
                    value: cVal,
                    maxValue: 3,
                    width: 10,
                    text: cVal,
                    colors: ['#e2e2e2', '#8bc34a'],
                    duration: 1200,
                    wrpClass: 'circles-wrp',
                    textClass: 'd-none',
                    valueStrokeClass: 'circles-valueStroke',
                    maxValueStrokeClass: 'circles-maxValueStroke',
                    styleWrapper: true,
                    styleText: true
                });
            });
            setTimeout(function() {
                ($('.list-circle-anim') as any ).tooltip({ trigger: 'manual', placement: 'top' }).tooltip('show').unbind();
            }, 1200);
        }

        getProductLink(product){
            return (product ? '<a target="_blank" href="'+product.details_url+'">'+product.name+'</a>' : '-');
        }

        get3dTourUrl(house){
            return baseUrlTo3DTour+'#house'+(house.sort/10);
        }

        trans(key){
            return translate(key);
        }

        houseUrl(house){
            return baseHouseUrl.replace('--slug--',house.seo.url);
        }

        updateCompareButtons(){
            let self = this;
            setTimeout(function(){
                ($('.vivapark-addtoCompare-item') as any).removeClass('added');
                ($('.vivapark-addtoCompare-item .vivapark-house-action') as any).removeClass('removeFromVivaParkCompare').addClass('addToVivaParkCompare');
                ($('.vivapark-addtoCompare-item .vivapark-house-action') as any).each(function(index,item){
                    ($(item) as any).text(($(item) as any).data('addtext'));
                });
                self.getCookie().forEach(function(item,index){
                    ($('.vivapark-addtoCompare-item-'+item) as any).addClass('added');
                    let actionButton = ($('.vivapark-addtoCompare-item-'+item) as any).find('.vivapark-house-action');
                    actionButton.text(actionButton.data('removetext'));
                    actionButton.toggleClass('addToVivaParkCompare removeFromVivaParkCompare')
                });
            },200);

        }

        getCookie() {
            const name = this.cookie_name + "=";
            const cDecoded = decodeURIComponent(document.cookie); //to be careful
            const cArr = cDecoded.split('; ');
            let res = '';
            cArr.forEach(val => {
                if (val.indexOf(name) === 0) res = val.substring(name.length);
            })
            return res.length ? JSON.parse(res) : [];
        }


        pageSelected(page){
            this.paginator.currentPage = page;
        }

        @Watch("data.filter", {immediate: true, deep: true})
        onUpdateFilter(newVal,oldVal){
            if(this.loadedHouses){
                history.pushState('', '', baseListUrl+'/'+newVal);
                this.loadHouses();
            }
        }
        @Watch("paginator.currentPage", {immediate: true, deep: true})
        onUpdatePage(newVal,oldVal){
            if(this.loadedHouses){
                this.loadHouses();
            }
        }
    }
